import Transportation from "../../../../patient/details/transportation/Transportation";

export default function TransportationTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}> 
        <Transportation inWorkQ={inWorkQ} />
    </div>
}